<main class="w-100 h-100 p-md-2 p-1" style="direction: rtl;">

    <section class="container p-md-4 p-0">

        <h1 class="fw-bold alert-warning p-3 rounded">

            <i class="fa fa-star" aria-hidden="true"></i>

            اعتبار سنجی تاکسی 
        
        </h1>

        <!--  -->

        <p class="fs-6 p-2 p-md-0"> در این بخش می‌توانید اطلاعات کامل تاکسی، شامل مشخصات خودرو، بازرسی‌های فنی و سایر جزئیات مرتبط
            را مشاهده کنید. برای این منظور، لطفاً شماره ثبت‌شده روی بدنه تاکسی را وارد کرده و سپس دکمه «بررسی کد» را انتخاب
            نمایید.
        </p>

        <!--  -->

        <div [formGroup]="mdl_Validate" class="row gx-0 gy-2 w-100 p-2">

            <div class="col-12 col-md-5">

                <div class="form-group w-100 has-icon">

                    <span class="form-control-icon">

                        <i class="fa fa-car" aria-hidden="true"></i>

                    </span>

                    <input oninput="this.value=this.value.replace(/[^0-9]/g,'')" formControlName="strCode"
                        placeholder="کد تاکسی را وارد کنید" class="form-control">

                </div>

            </div>

            <div class="col-12 col-md-auto px-md-2">

                <button class="w-100 btn btn-primary" (click)="checkOut_Truck()">

                    &nbsp; بررسی کد &nbsp;

                </button>

            </div>

            <!-- اطلاعات راننده -->

            <ng-container *ngIf="information_ads?.strFullName">

                <div class="col-12 mt-3 border-top">

                    <!-- اطلاعات آگهی -->

                    <section class="main-container row w-full gx-2 p-2">

                        <!-- اطلاعات سمت راست -->

                        <div class="col-12 col-md-6 p-2">

                            <div class="w-100 h-100 p-2">

                                <!-- عنوان -->

                                <h1 class="fw-bold mb-2 pb-3 border-bottom d-flex justify-content-between align-items-center" style="pointer-events: none;">

                                    <span> {{ information_ads.strFullName }} </span>

                                    <ngx-star-rating formControlName="rating1"></ngx-star-rating>

                                </h1>

                                <!-- تاریخ مرخصی -->

                                <ng-container *ngIf="information_ads?.strVacation_SDate">

                                    <h5 class="alert-info fs-6 px-2 pt-3 pb-4" style="pointer-events: none;line-height: 30px;">
    
                                        این خودرو از تاریخ <b>{{ information_ads?.strVacation_SDate | faNum }} </b> تا تاریخ <b>{{ information_ads?.strVacation_EDate | faNum }}</b> در مرخصی می باشد. 
    
                                    </h5>

                                </ng-container>

                                <!-- دکمه ها -->

                                <div class="ads-operation w-100 d-flex justify-content-between py-2">

                                    <div class="buttons-container d-flex">

                                        <!-- گزارش -->

                                        <div class="ads-call mx-2">

                                            <button class="btn text-white central px-md-4 px-2 pointer"
                                                style="background-color: #5c636a;border-color: #565e64;"
                                                (click)="goTo_Support()">

                                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>

                                                <span class="mx-2"> گزارش </span>

                                            </button>

                                        </div>

                                    </div>

                                    <div class="ads-share-bookmark d-flex align-items-center justify-content-end w-25">

                                        <span class="d-flex material-symbols-outlined" (click)="shareVia()">

                                            <!-- <mat-icon class="mat-18 text-muted pointer">share</mat-icon> -->

                                            <i class="fa fa-share-alt text-muted pointer fa-lg" aria-hidden="true"></i>


                                        </span>


                                    </div>

                                </div>

                                <!-- اطلاعات آگهی گذار -->

                                <div [@slideInOut]="information_ads?.strMobile ? 'open' : 'closed'"
                                    class="ads-address-number-show w-100 p-2 mt-2">

                                    <div class="d-flex justify-content-between mb-4">

                                        <span> شماره موبایل </span>

                                        <div class="d-flex align-items-center pointer" (click)="callWith_advertiser()">

                                            <span class="mx-2"> {{ information_ads?.strMobile | faNum }} </span>

                                            <span class="d-flex material-symbols-outlined">

                                                <i class="fa fa-phone text-muted fa-lg" aria-hidden="true"></i>

                                            </span>

                                        </div>

                                    </div>

                                    <div style="background-color: #F0FAFF;" class="rounded-sm p-3 ">

                                        <p class="fw-bold"> هشدار </p>

                                        <span class="text-muted"> لطفاً پیش از انجام معامله و هر نوع پرداخت وجه، از صحت
                                            خودرو یا خدمات ارائه‌شده، به‌صورت حضوری اطمینان حاصل نمایید. </span>

                                    </div>

                                </div>

                                <!-- اطلاعات عمودی -->

                                <div class="ads-vertical p-4">

                                    <div *ngFor="let item of information_ads.lstHorizontalInfo;let i = index;"
                                        [ngClass]=" true ? 'ads-info-' + (i+1) : '' " class="text-center col-4">

                                        <span [innerHTML]="getSafeHtml(item.strTitle)" class="text-muted"> {{
                                            item.strTitle || ' ' }} </span>

                                        <h2 class="mb-0" style="line-height: initial!important;">

                                            <span [innerHTML]="getSafeHtml(item.strValue)" class="text-dark fw-bold">

                                                {{ (item.strValue | faNum) || ' '}}

                                            </span>


                                        </h2>

                                    </div>

                                </div>

                                <!-- اطلاعات افقی -->

                                <ng-container *ngFor="let item of information_ads.lstverticalInfo;let i = index;">

                                    <ng-container *ngIf="item.strValue">

                                        <div class="ads-horizontal">

                                            <div class="ads-horizontal w-100 d-flex justify-content-between mt-2 p-2">
        
                                                <span [innerHTML]="getSafeHtml(item.strTitle)" class="text-muted"></span>
        
                                                <span [innerHTML]="getSafeHtml(item.strValue | faNum)" class="text-dark fw-bold"></span>
        
                                            </div>

                                        </div>

                                        <hr class="ads-divider m-0 w-100">

                                    </ng-container>

                                </ng-container>

                            </div>

                        </div>

                        <!-- اطلاعات سمت چپ -->

                        <div class="col-12 col-md-6 h-100 p-2">

                            <div class="w-100 h-100 p-2">

                                <div class="ads-images-container h-65">

                                    <!-- عکس اصلی -->

                                    <div class="ads-images-preview h-75">

                                        <div class="position-relative w-full h-100 rounded">

                                            <img class="w-100 h-100 rounded" [src]="information_ads?.list_Gallery.length > 0 ? 'data:image/jpeg;base64,' + information_ads.list_Gallery[0] : '../../../assets/Img/preview__thumbnail.png'" [alt]="information_ads?.strFullName || 'تصویر راننده'">

                                            <span *ngIf="information_ads?.list_Gallery.length > 0"
                                                class="position-absolute pointer"
                                                (click)="openGallery(information_ads?.list_Gallery?.[0],0)">

                                                <i class="fa fa-arrows-alt mx-1" aria-hidden="true"></i>

                                                {{ information_ads?.list_Gallery.length | faNum }}


                                            </span>

                                        </div>

                                    </div>

                                    <!-- بقیه تصاویر -->

                                    <div *ngIf="information_ads?.list_Gallery.length > 1"
                                        class="ads-images-all w-full row dil gx-2 pt-1 h-25" style="direction: ltr;">

                                        <div *ngFor="let item of list_AdsImagesShown;let i = index"
                                            class="ads-image col-md-4 col-6 p-2">

                                            <div class="w-full h-100 rounded position-relative"
                                                (click)="openGallery(item,i)">

                                                <ng-container *ngIf=" i == 0">

                                                    <div *ngIf="list_AdsImagesCounter > 0" class="pic-counter pointer">

                                                        + {{ list_AdsImagesCounter | faNum }}

                                                    </div>

                                                </ng-container>

                                                <img class="w-100 h-100 rounded"
                                                    src="{{'data:image/jpeg;base64,' + item}}"
                                                    [alt]="information_ads?.strTitle">

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </section>

                </div>

            </ng-container>

            <!-- ثبت نظر -->

            <ng-container *ngIf="information_ads?.strFullName">

                <div class="col-12 row gx-0 gy-3 p-2 mt-3">

                    <h5 class="col-12">دیدگاه خود را بنویسید</h5>

                    <!-- نام و نام خانوادگی -->

                    <div class="col-md-6 col-12 px-md-2 px-0">

                        <div class="form-group w-100 has-icon">

                            <span class="form-control-icon">

                                <!-- <mat-icon aria-hidden="true">person</mat-icon> -->

                                <i class="fa fa-user" aria-hidden="true"></i>

                            </span>

                            <input placeholder="نام و نام خانوادگی" class="form-control">

                        </div>

                    </div>

                    <!-- ایمیل -->

                    <div class="col-md-6 col-12 px-md-2 px-0">

                        <div class="form-group w-100 has-icon">

                            <span class="form-control-icon">

                                <i class="fa fa-envelope-o" aria-hidden="true"></i>

                            </span>

                            <input placeholder="ایمیل" class="form-control">

                        </div>

                    </div>

                    <!-- دیدگاه کاربر -->

                    <div class="col-12 px-md-2 px-0">

                        <textarea style="height: 150px;" class="w-100 form-control"
                            placeholder="دیدگاه خود را درباره این راننده بنویسید..."></textarea>

                    </div>

                    <div class="col-12 px-md-2 px-0 text-start">

                        <button class="btn btn-success"> ثبت دیدگاه </button>

                    </div>

                </div>

            </ng-container>

            <!-- نظرات کاربران -->

            <ng-container *ngIf="information_ads?.strFullName">

                <div class="col-12 px-md-2 px-0 mt-3 border-top pt-3">

                    <h5 class="fw-bold"> نظرات کاربران ({{ information_ads.lstComments.length | faNum }})</h5>

                    <div class="w-100 p-md-5 p-0" style="background-color: #F5F5F5;">

                        <div class="p-2">

                            <ng-container *ngFor="let item of information_ads.lstComments">

                                <div class="hangout-comment comment-body px-1 mb-5">

                                    <!-- تصویر کامنت گذار  -->

                                    <div class="comment-avatar col-auto">

                                        <img src="{{ item?.strImage && item.strImage != '' ? 'data:image/jpeg;base64,' + item.strImage  : '../../../assets/imgs/user_profile.png' }}"
                                            [alt]="item?.strFullName">

                                    </div>

                                    <!-- اسم کامنت گذار -->

                                    <div class="comment-name col-auto">

                                        <span class="mx-2"> {{item.strNikName || 'کاربر امدادران'}} </span>

                                        <span style="font-size: 12px;" class="text-muted"> {{ item.strDate ||
                                            '1403/11/08' | faNum }} </span>

                                    </div>

                                    <!-- متن کامنت گذار -->

                                    <div class="comment-content col-12">

                                        <span style="font-size: 12px;"> {{item.strComment || item }} </span>

                                    </div>

                                </div>

                            </ng-container>

                        </div>

                    </div>

                </div>

            </ng-container>

        </div>

        <!-- گالری تصاویر -->

        <div class="modal fade dir" id="galleryComp_Modal" role="dialog">

            <div class="modal-dialog modal-fullscreen modal-dialog-centered">

                <div class="modal-content">

                    <div class="modal-header d-flex justify-content-between">

                        <h3 class="modal-title mb-0"> گالری تصاویر </h3>

                        <button type="button" class="btn-close p-0 m-0" data-bs-dismiss="modal"></button>

                    </div>

                    <div class="modal-body">

                        <ng-container *ngIf="isAlbum">

                            <custom-gallery [albumIndex]="albumIndex" [lst_Album]="lst_Album" [isDownloadAble]="false"
                                [strKey_list]="'strImage'">

                            </custom-gallery>

                        </ng-container>

                    </div>

                </div>

            </div>

        </div>

    </section>

</main>